import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

class ProductData {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.sizesEl = this.root.querySelector('[product-data-sizes]');

        this.sizesSwiper = null;

        return true;
    }

    init() {
        this.setSizesSlider();
        window.addEventListener('resize', this.setSizesSlider);
    }

    setSizesSlider() {
        if (!this.sizesEl) return;
        const { innerWidth } = window;

        if (innerWidth < 1280) {
            this.sizesSwiper = new Swiper(this.sizesEl, {
                modules: [Autoplay, Navigation],
                loop: false,
                speed: 650,
                autoplay: {
                    delay: 3000,
                },
                slidesPerView: 2.25,
                spaceBetween: 24,
            });
        } else {
            if (this.sizesSwiper) {
                this.sizesSwiper.destroy();
                this.sizesSwiper = null;
            }
        }
    }
}

const sections = document.querySelectorAll('[product-data]');
const initProductData = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new ProductData(el);
    });
};

initProductData(sections);
